/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/content-anchor": dynamic(() => import("../../../blocks/content/anchor.tsx"), "blocks/content/anchor.tsx"),
  "acf/content-contact-form": dynamic(
    () => import("../../../blocks/content/contact-form.tsx"),
    "blocks/content/contact-form.tsx",
  ),
  "acf/content-cta": dynamic(() => import("../../../blocks/content/cta.tsx"), "blocks/content/cta.tsx"),
  "acf/content-detailed-cta": dynamic(
    () => import("../../../blocks/content/detailed-cta.tsx"),
    "blocks/content/detailed-cta.tsx",
  ),
  "acf/content-expandable": dynamic(
    () => import("../../../blocks/content/expandable.tsx"),
    "blocks/content/expandable.tsx",
  ),
  "acf/content-expandable-item": dynamic(
    () => import("../../../blocks/content/expandable-item.tsx"),
    "blocks/content/expandable-item.tsx",
  ),
  "acf/content-features-grid": dynamic(
    () => import("../../../blocks/content/features-grid.tsx"),
    "blocks/content/features-grid.tsx",
  ),
  "acf/content-features-tabs": dynamic(
    () => import("../../../blocks/content/features-tabs.tsx"),
    "blocks/content/features-tabs.tsx",
  ),
  "acf/content-generic-header": dynamic(
    () => import("../../../blocks/content/generic-header.tsx"),
    "blocks/content/generic-header.tsx",
  ),
  "acf/content-hubspot-form": dynamic(
    () => import("../../../blocks/content/hubspot-form.tsx"),
    "blocks/content/hubspot-form.tsx",
  ),
  "acf/content-image-columns": dynamic(
    () => import("../../../blocks/content/image-columns.tsx"),
    "blocks/content/image-columns.tsx",
  ),
  "acf/content-image-marquee": dynamic(
    () => import("../../../blocks/content/image-marquee.tsx"),
    "blocks/content/image-marquee.tsx",
  ),
  "acf/content-insights-collage": dynamic(
    () => import("../../../blocks/content/insights-collage.tsx"),
    "blocks/content/insights-collage.tsx",
  ),
  "acf/content-insights-grid": dynamic(
    () => import("../../../blocks/content/insights-grid.tsx"),
    "blocks/content/insights-grid.tsx",
  ),
  "acf/content-landing-intro": dynamic(
    () => import("../../../blocks/content/landing-intro.tsx"),
    "blocks/content/landing-intro.tsx",
  ),
  "acf/content-media-and-text": dynamic(
    () => import("../../../blocks/content/media-and-text.tsx"),
    "blocks/content/media-and-text.tsx",
  ),
  "acf/content-product-cards": dynamic(
    () => import("../../../blocks/content/product-cards.tsx"),
    "blocks/content/product-cards.tsx",
  ),
  "acf/content-product-header": dynamic(
    () => import("../../../blocks/content/product-header.tsx"),
    "blocks/content/product-header.tsx",
  ),
  "acf/content-section": dynamic(() => import("../../../blocks/content/section.tsx"), "blocks/content/section.tsx"),
  "acf/content-statistics": dynamic(
    () => import("../../../blocks/content/statistics.tsx"),
    "blocks/content/statistics.tsx",
  ),
  "acf/content-text-marquee": dynamic(
    () => import("../../../blocks/content/text-marquee.tsx"),
    "blocks/content/text-marquee.tsx",
  ),
  "acf/content-title-and-definitions": dynamic(
    () => import("../../../blocks/content/title-and-definitions.tsx"),
    "blocks/content/title-and-definitions.tsx",
  ),
  "acf/content-two-column-media-text": dynamic(
    () => import("../../../blocks/content/two-column-media-text.tsx"),
    "blocks/content/two-column-media-text.tsx",
  ),
  "acf/content-two-column-rich-text": dynamic(
    () => import("../../../blocks/content/two-column-rich-text.tsx"),
    "blocks/content/two-column-rich-text.tsx",
  ),
  "acf/content-two-column-text": dynamic(
    () => import("../../../blocks/content/two-column-text.tsx"),
    "blocks/content/two-column-text.tsx",
  ),
  "acf/insight-insight-header": dynamic(
    () => import("../../../blocks/insight/insight-header.tsx"),
    "blocks/insight/insight-header.tsx",
  ),
  "acf/leadership-leadership-header": dynamic(
    () => import("../../../blocks/leadership/leadership-header.tsx"),
    "blocks/leadership/leadership-header.tsx",
  ),
  ...core,
};

const info = {
  "acf/content-anchor": { "slug": "content/anchor", "tags": ["#page"], "flags": {} },
  "acf/content-contact-form": { "slug": "content/contact-form", "tags": ["#page"], "flags": {} },
  "acf/content-cta": { "slug": "content/cta", "tags": ["#page"], "flags": {} },
  "acf/content-detailed-cta": { "slug": "content/detailed-cta", "tags": ["#page"], "flags": {} },
  "acf/content-expandable": { "slug": "content/expandable", "tags": ["#page"], "flags": {} },
  "acf/content-expandable-item": { "slug": "content/expandable-item", "flags": {} },
  "acf/content-features-grid": { "slug": "content/features-grid", "tags": ["#page"], "flags": {} },
  "acf/content-features-tabs": { "slug": "content/features-tabs", "tags": ["#page"], "flags": {} },
  "acf/content-generic-header": { "slug": "content/generic-header", "tags": ["#page"], "flags": {} },
  "acf/content-hubspot-form": { "slug": "content/hubspot-form", "tags": ["#page"], "flags": {} },
  "acf/content-image-columns": { "slug": "content/image-columns", "tags": ["#page"], "flags": {} },
  "acf/content-image-marquee": { "slug": "content/image-marquee", "tags": ["#page"], "flags": {} },
  "acf/content-insights-collage": { "slug": "content/insights-collage", "tags": ["#page"], "flags": {} },
  "acf/content-insights-grid": { "slug": "content/insights-grid", "tags": ["#page"], "flags": {} },
  "acf/content-landing-intro": { "slug": "content/landing-intro", "tags": ["#page"], "flags": {} },
  "acf/content-media-and-text": { "slug": "content/media-and-text", "tags": ["#page"], "flags": {} },
  "acf/content-product-cards": { "slug": "content/product-cards", "tags": ["#page"], "flags": {} },
  "acf/content-product-header": { "slug": "content/product-header", "tags": ["#page"], "flags": {} },
  "acf/content-section": { "slug": "content/section", "flags": {} },
  "acf/content-statistics": { "slug": "content/statistics", "tags": ["#page"], "flags": {} },
  "acf/content-text-marquee": { "slug": "content/text-marquee", "tags": ["#page"], "flags": {} },
  "acf/content-title-and-definitions": { "slug": "content/title-and-definitions", "tags": ["#page"], "flags": {} },
  "acf/content-two-column-media-text": { "slug": "content/two-column-media-text", "tags": ["#page"], "flags": {} },
  "acf/content-two-column-rich-text": { "slug": "content/two-column-rich-text", "tags": ["#page"], "flags": {} },
  "acf/content-two-column-text": { "slug": "content/two-column-text", "tags": ["#page"], "flags": {} },
  "acf/insight-insight-header": { "slug": "insight/insight-header", "tags": [], "flags": {} },
  "acf/leadership-leadership-header": { "slug": "leadership/leadership-header", "tags": [], "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
